export default "__VITE_ASSET__Bs_gfKAY__"